export const firebaseConfig = {
  apiKey: 'AIzaSyDcUw63kNVZDNCbICYVMRVvtbbiR-qVkmM',
  authDomain: 'domustudio-fornitori.firebaseapp.com',
  projectId: 'domustudio-fornitori',
  storageBucket: 'domustudio-fornitori.appspot.com',
  messagingSenderId: '482609826837',
  appId: '1:482609826837:web:2f9acaa155906be952d21c'
};

export const VAPID = 'BBP4DG3xj0tiSN3MhpUV6wL33iS1hpNcSuFejMj4jk4bLRWNnjbLFthuueY4bvotQc54kftCgaDtg2Y7q47MH_I';
